import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { LeaderboardServices, EventServices, TicketingServices, PlanningServices } from '../middlewares/services'
import { getMyPartnerEvents } from '../middlewares/services/partner.services'
import { useAuth } from '../middlewares/auth/auth-context'
import { useError } from '../contexts/error-context'

export const PUBLISH_TYPES = {
    LEADERBOARD: 'LEADERBOARD',
    EVENT: 'EVENT',
    TICKETING: 'TICKETING',
    PLANNING: 'PLANNING',
}

/**
 * redirect to page not found if user is not admin or orga and competition is not published
 * @param {*} eventIdentifier
 * @returns canEdit boolean, that stands to
 */
export default function useIsPublished(eventIdentifier, type = PUBLISH_TYPES.LEADERBOARD) {
    const location = useLocation()
    const errorContext = useError()
    const authContext = useAuth()

    const [isCheckingPublished, setIsCheckingPublished] = useState(true)
    const [canEdit, setCanEdit] = useState(false)

    useEffect(() => {
        const CheckEditingPossibility = (orgaId) => {
            if (authContext.isAdmin || authContext.user.id == orgaId) {
                return true
            }
            if (authContext.user.type == 'athlete') {
                return false
            }
            return false
        }
        const isPartnerForEvent = async () => {
            if (!authContext.isLoggedIn) return false
            try {
                const { data } = await getMyPartnerEvents()
                if (!data?.isPartner) return false
                return (data.events ?? []).some(
                    (e) =>
                        String(e._id) === String(eventIdentifier) ||
                        String(e.eventNumber) === String(eventIdentifier),
                )
            } catch {
                return false
            }
        }
        const ManageError = () => {
            errorContext.setError({ location })
            setIsCheckingPublished(false)
        }
        const ManageResult = async (response) => {
            const { published, orgaId } = response.data
            console.log('/CheckIfPublished - ManageResult', type, published)

            const isTheRightUser = CheckEditingPossibility(orgaId)

            setCanEdit(isTheRightUser)

            let canView = isTheRightUser || published
            if (!canView && type === PUBLISH_TYPES.LEADERBOARD) {
                canView = await isPartnerForEvent()
            }

            if (canView) {
                setIsCheckingPublished(false)
            } else {
                const errorObject = {
                    type: 404,
                    location,
                    PUBLISH_TYPES: type,
                    published,
                }
                if (type == PUBLISH_TYPES.TICKETING) {
                    errorObject.type = 401
                    errorObject.open_date = response?.data?.open_date
                }
                errorContext.setError(errorObject)
            }
        }
        const CheckIfPublished = async () => {
            switch (type) {
                case PUBLISH_TYPES.LEADERBOARD:
                    await LeaderboardServices.IsPublished(eventIdentifier).then(ManageResult).catch(ManageError)
                    break
                case PUBLISH_TYPES.EVENT:
                    await EventServices.IsPublished(eventIdentifier).then(ManageResult).catch(ManageError)
                    break
                case PUBLISH_TYPES.TICKETING:
                    await TicketingServices.IsPublished(eventIdentifier).then(ManageResult).catch(ManageError)
                    break
                case PUBLISH_TYPES.PLANNING:
                    await PlanningServices.IsPublished(eventIdentifier).then(ManageResult).catch(ManageError)
                    break
            }
        }

        CheckIfPublished()
    }, [])

    return [canEdit, isCheckingPublished]
}

